var productHasBothEngravingTypes = false;
var productOnlyHasSingleWinnerEngravingType = false;
var productOnlyHasPerpetualEngravingType = false;

var productVariants = productObj.variants;
for(var i = 0, l = productVariants.length, variantSKU; i < l; i++ ){
  variantSKU = productVariants[ i ].sku;
  if(engravingMap.hasOwnProperty( variantSKU ) && engravingMap[ variantSKU ]['Single Winner Engraving SKU'] !== '' && engravingMap[ variantSKU ]['Perpetual Engraving SKU'] !== ''){
    productHasBothEngravingTypes = true;
    break;
  }
}
// console.log("productHasBothEngravingTypes",productHasBothEngravingTypes);
// if(document.body.classList.contains("template-belt-product-ffl")){
//   productHasBothEngravingTypes = true;
// }

if(!productHasBothEngravingTypes){
  for(var i = 0, l = productVariants.length, variantSKU; i < l; i++){
    variantSKU = productVariants[i].sku;
    if(!engravingMap.hasOwnProperty(variantSKU)){continue;}
    if(engravingMap[variantSKU]['Single Winner Engraving SKU'] !== ''){
      productOnlyHasSingleWinnerEngravingType = true;
      break;
    }
    if(engravingMap[variantSKU]['Perpetual Engraving SKU'] !== ''){
      productOnlyHasPerpetualEngravingType = true;
      break;
    }
  }
}

productHasBothEngravingTypes = true;
if(document.querySelector(".product.both-engraving-types--false")){
  productHasBothEngravingTypes = false;
}
// console.log("productHasBothEngravingTypes",productHasBothEngravingTypes,productObj);
if(productHasBothEngravingTypes){
  let engraveBtns = document.querySelector("[data-engraving-buttons]") || null;
  if(engraveBtns) engraveBtns.classList.remove("hidden");
}


let leagueWrap = document.querySelector("[data-engraving-league]") || null;
let singlePreview = document.querySelector("[data-engraving-single-preview]") || null;

let perpetualBtn = document.querySelector("[data-perpetual-btn]") || null;
let singleWinnerBtn = document.querySelector("[data-single-winner-btn]") || null;

// btns click event
let addBtn = document.querySelector("[data-line-add-btn]") || null;
let removeBtn = document.querySelector("[data-line-remove-btn]") || null;

// perpetualBtn btn click event
if(perpetualBtn){
  perpetualBtn.addEventListener("click",function(e){
    e.preventDefault();
    perpetualBtn.classList.toggle("active");
    if(singleWinnerBtn) singleWinnerBtn.classList.toggle("active");
    if(singlePreview) singlePreview.classList.add("hidden");
    if(leagueWrap) leagueWrap.classList.remove("hidden");
    if(addBtn) addBtn.classList.remove("hidden");
    if(removeBtn) removeBtn.classList.remove("hidden");
    if(document.querySelector("[data-engraving-wrap]")){
      document.querySelector("[data-engraving-wrap]").classList.toggle("perpetual-btn-active");
      document.querySelector("[data-engraving-wrap]").classList.remove("s-winner-btn-active");
    }
    manageInputRows("perpetual");

    // change property for perpetual
    let propField = document.querySelector("[data-property-fields] [data-property-field-item]");
    // console.log("propField",propField);
    if(propField){
      let fields = propField.querySelectorAll(".line-item-property__field");
      fields.forEach((f, index) => {
        f.querySelector("input").setAttribute("name",f.querySelector("input").dataset.name);
      });
    }
    
  });
}

// singleWinnerBtn click event
if(singleWinnerBtn){
  singleWinnerBtn.addEventListener("click",function(e){
    e.preventDefault();
    singleWinnerBtn.classList.toggle("active");
    if(perpetualBtn) perpetualBtn.classList.toggle("active");
    if(singlePreview) singlePreview.classList.remove("hidden");
    if(leagueWrap) leagueWrap.classList.add("hidden");
    if(addBtn) addBtn.classList.add("hidden");
    if(removeBtn) removeBtn.classList.add("hidden");
    if(document.querySelector("[data-engraving-wrap]")){
      document.querySelector("[data-engraving-wrap]").classList.toggle("s-winner-btn-active");
      document.querySelector("[data-engraving-wrap]").classList.remove("perpetual-btn-active");
    }
    manageInputRows("single");
    
    // change property for singleWinner
    let propField = document.querySelector("[data-property-fields] [data-property-field-item]");
    // console.log("propField",propField);
    if(propField){
      let fields = propField.querySelectorAll(".line-item-property__field");
      fields.forEach((f, index) => {
        let propName = `properties[L${index + 1}Text]`;
        // console.log("propName",propName);
        if(f.querySelector(".for-single-winner").dataset.name){
          propName = f.querySelector(".for-single-winner").dataset.name;
          f.querySelector("input").setAttribute("name",propName);
        }else if(document.body.classList.contains("template-custom-perpetual-new")){
          f.querySelector("input").setAttribute("name",propName);
        }
      });
    }
    
  });
}

// if single winner btn click then hide other input rows
function manageInputRows(btnType){
  
  let inputRows = document.querySelectorAll("[data-property-field-item]");
  if(inputRows.length > 1){
    inputRows.forEach((row, index) => {
      // console.log("index",index);
      if(index > 0){
        if(btnType == "single"){
          row.classList.add("hidden");
        }else{
          row.classList.remove("hidden");
        }
      }
    });
  }
}

// addBtn btn click
if(addBtn){
  addBtn.addEventListener("click",function() {
    let propertyFieldWrap = document.querySelector("[data-property-fields]") || null;
    let propertyFields = document.querySelectorAll("[data-property-fields] [data-property-field-item]");
    
      let length = propertyFields.length;
      let lastItem = propertyFields[propertyFields.length - 1];
      let inputs = lastItem.querySelectorAll("input");
      if(inputs.length){
        let blankVal = 0;
        inputs.forEach(input => {
          if(input.value == ''){
            blankVal++;
          }
        });
        // console.log("blankVal",blankVal);
        // blank value > 1 --> show error msg
        if(blankVal > 1 && propertyFieldWrap){
          let errWrap = propertyFieldWrap.querySelector(".engraving-error");
          if(errWrap) errWrap.remove();
          errWrap = document.createElement("div");
          errWrap.classList.add("engraving-error");
          errWrap.innerText = "Error: Two Fields Required";
          propertyFieldWrap.appendChild(errWrap);
          $(".engraving-error").fadeIn().delay(2000).fadeOut();
          return false;
        }
      }

      // clone inputs
      let len = document.querySelectorAll("[data-property-fields] [data-property-field-item]").length;
    const el = document.querySelector('.line-item-property__actions');
    if (!(len >= el.dataset.properties)) {
      let newNumber = len + 1;
      if(document.querySelector(".property-fields__rows.product-engraving-default")){
        newNumber = newNumber - 1;
      }
      if(document.body.classList.contains("template-belt-product-ffl")){
        newNumber = newNumber - 1;
      }
      let cloneEle = propertyFields[0].cloneNode(true);
      cloneEle.setAttribute("id",`property-fields__row-${newNumber}`)

      if(window.productObj.tags.includes("Baseball") || window.productObj.tags.includes("Basketball")){
        if(document.querySelector(".property-fields__rows.product-engraving-default")){
          let dataNameYear = cloneEle.querySelector(".line-item-property__year input").getAttribute("data-name");
          dataNameYear = dataNameYear.substring(11);
          dataNameYear = dataNameYear.replace("]","");
          // console.log("dataNameYear",dataNameYear);
          cloneEle.querySelector(".line-item-property__year label.for-single-winner").setAttribute("for",`year_${newNumber}`);
          cloneEle.querySelector(".line-item-property__year input").setAttribute("id",`year_${newNumber}`);
          cloneEle.querySelector(".line-item-property__year input").setAttribute("name",`properties[${dataNameYear} ${newNumber}]`);
          cloneEle.querySelector(".line-item-property__year input").value = '';

          let dataNameTeam = cloneEle.querySelector(".line-item-property__team input").getAttribute("data-name");
          dataNameTeam = dataNameTeam.substring(11);
          dataNameTeam = dataNameTeam.replace("]","");
          // console.log("dataNameTeam",dataNameTeam);
          cloneEle.querySelector(".line-item-property__team label.for-single-winner").setAttribute("for",`team-name_${newNumber}`);
          cloneEle.querySelector(".line-item-property__team input").setAttribute("id",`team-name_${newNumber}`);
          cloneEle.querySelector(".line-item-property__team input").setAttribute("name",`properties[${dataNameTeam} ${newNumber}]`);
          cloneEle.querySelector(".line-item-property__team input").value = '';

          let dataNameName = cloneEle.querySelector(".line-item-property__name input").getAttribute("data-name");
          dataNameName = dataNameName.substring(11);
          dataNameName = dataNameName.replace("]","");
          // console.log("dataNameName",dataNameName);
          cloneEle.querySelector(".line-item-property__name label.for-single-winner").setAttribute("for",`winner-name_${newNumber}`);
          cloneEle.querySelector(".line-item-property__name input").setAttribute("id",`winner-name_${newNumber}`);
          cloneEle.querySelector(".line-item-property__name input").setAttribute("name",`properties[${dataNameName} ${newNumber}]`);
          cloneEle.querySelector(".line-item-property__name input").value = '';
          
        }else{
          let dataNameYear = cloneEle.querySelector(".line-item-property__year input").getAttribute("data-name");
          dataNameYear = dataNameYear.substring(11);
          dataNameYear = dataNameYear.replace("]","");
          // console.log("dataNameYear",dataNameYear);
          cloneEle.querySelector(".line-item-property__year label.for-single-winner").setAttribute("for",`year_${newNumber}`);
          cloneEle.querySelector(".line-item-property__year input").setAttribute("id",`year_${newNumber}`);
          cloneEle.querySelector(".line-item-property__year input").setAttribute("name",`properties[${dataNameYear} ${newNumber}]`);
          cloneEle.querySelector(".line-item-property__year input").value = '';

          let dataNameTeam = cloneEle.querySelector(".line-item-property__team input").getAttribute("data-name");
          dataNameTeam = dataNameTeam.substring(11);
          dataNameTeam = dataNameTeam.replace("]","");
          // console.log("dataNameTeam",dataNameTeam);
          cloneEle.querySelector(".line-item-property__team label.for-single-winner").setAttribute("for",`team-name_${newNumber}`);
          cloneEle.querySelector(".line-item-property__team input").setAttribute("id",`team-name_${newNumber}`);
          cloneEle.querySelector(".line-item-property__team input").setAttribute("name",`properties[${dataNameTeam} ${newNumber}]`);
          cloneEle.querySelector(".line-item-property__team input").value = '';

          let dataNameName = cloneEle.querySelector(".line-item-property__name input").getAttribute("data-name");
          dataNameName = dataNameName.substring(11);
          dataNameName = dataNameName.replace("]","");
          // console.log("dataNameName",dataNameName);
          cloneEle.querySelector(".line-item-property__name label.for-single-winner").setAttribute("for",`winner-name_${newNumber}`);
          cloneEle.querySelector(".line-item-property__name input").setAttribute("id",`winner-name_${newNumber}`);
          cloneEle.querySelector(".line-item-property__name input").setAttribute("name",`properties[${dataNameName} ${newNumber}]`);
          cloneEle.querySelector(".line-item-property__name input").value = '';
        }
      }else{
        
        let dataNameYear = cloneEle.querySelector(".line-item-property__year input").getAttribute("data-name");
        dataNameYear = dataNameYear.substring(11);
        dataNameYear = dataNameYear.replace("]","");
        // console.log("dataNameYear",dataNameYear);
        cloneEle.querySelector(".line-item-property__year label.for-perpetual").setAttribute("for",`year_${newNumber}`);
        cloneEle.querySelector(".line-item-property__year input").setAttribute("id",`year_${newNumber}`);
        // cloneEle.querySelector(".line-item-property__year input").setAttribute("name",`properties[YEAR ${newNumber}]`);
        cloneEle.querySelector(".line-item-property__year input").setAttribute("name",`properties[${dataNameYear} ${newNumber}]`);
        cloneEle.querySelector(".line-item-property__year input").value = '';

        let dataNameTeam = cloneEle.querySelector(".line-item-property__team input").getAttribute("data-name");
        dataNameTeam = dataNameTeam.substring(11);
        dataNameTeam = dataNameTeam.replace("]","");
        // console.log("dataNameTeam",dataNameTeam);
        cloneEle.querySelector(".line-item-property__team label.for-perpetual").setAttribute("for",`team-name_${newNumber}`);
        cloneEle.querySelector(".line-item-property__team input").setAttribute("id",`team-name_${newNumber}`);
        cloneEle.querySelector(".line-item-property__team input").setAttribute("name",`properties[${dataNameTeam} ${newNumber}]`);
        cloneEle.querySelector(".line-item-property__team input").value = '';

        let dataNameName = cloneEle.querySelector(".line-item-property__name input").getAttribute("data-name");
        dataNameName = dataNameName.substring(11);
        dataNameName = dataNameName.replace("]","");
        // console.log("dataNameName",dataNameName);
        cloneEle.querySelector(".line-item-property__name label.for-perpetual").setAttribute("for",`winner-name_${newNumber}`);
        cloneEle.querySelector(".line-item-property__name input").setAttribute("id",`winner-name_${newNumber}`);
        cloneEle.querySelector(".line-item-property__name input").setAttribute("name",`properties[${dataNameName} ${newNumber}]`);
        cloneEle.querySelector(".line-item-property__name input").value = '';
      }
      // console.log("cloneEle",cloneEle);
      // reInit element array
      propertyFields = document.querySelectorAll("[data-property-fields] [data-property-field-item]")
      propertyFields[propertyFields.length - 1].after(cloneEle);
      removeBtn.removeAttribute("disabled");
      if(newNumber == window.productObj.base_count){
        this.setAttribute("disabled","disabled");
      }
    }
  
  });
}

// removeBtn btn click
if(removeBtn){
  removeBtn.addEventListener("click",function() {
    let propertyFields = document.querySelectorAll("[data-property-fields] [data-property-field-item]");
    if(propertyFields.length){
      let length = propertyFields.length;
      propertyFields[propertyFields.length-1].remove();
      if(addBtn){
        addBtn.removeAttribute("disabled");
      }
      // because length not update so == 2
      if(length == 2){
        this.setAttribute("disabled","disabled");
      }
    }
  });
}